import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Switch from '@material-ui/core/Switch'
// import AddCustomerPaymentMethods from './AddCustomerPaymentMethods'
// import AddCustomerEcheck from './AddCustomerEcheck'
import ServiceDetailList from './ServiceDetailList'
import InvoiceOptionsModal from './InvoiceOptionsModal'
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, CircularProgress }  from '@material-ui/core';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
// import DialogContentText from '@material-ui/core/DialogContentText';
import CloseIcon from '@material-ui/icons/Close';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
// import styles from './customer.module.scss'
import KeyDetails from '../Equipment/KeyDetails'
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import { useHistory } from 'react-router-dom'
import CrewSelector from '../Common/CrewSelector'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const useStyles = makeStyles(theme => ({
  root: {
    width: '80%',
    margin: '20px'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  gridParent: {
    margin: '10px',
    padding: '10px',
    width: '95%',
    border: '3px solid #aaa',
    borderRadius: '20px'
  },
  gridItem: {
    padding: '5px'
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paymentProfiles: {
    border: '1px solid',
    // marginRight: '5px',
    // padding: '5px'
  },
  bigText: {
    fontSize: '1.5em',
    color: '#333',
    textAlign: 'center'
  },
  paddedStuff: {
    padding: '5px',
    // margin: '5px'
  }
}));

// function htmlToText(html){
//   // console.log('Strip html tags: ', html)
//   //remove code brakes and tabs
//   html = html.replace(/\n/g, "");
//   html = html.replace(/\t/g, "");

//   //keep html brakes and tabs
//   html = html.replace(/<table>/g, "");
//   html = html.replace(/<tr>/g, "");
//   html = html.replace(/<td>/g, "");
//   html = html.replace(/<\/td>/g, "\t");
//   html = html.replace(/<\/table>/g, "\n");
//   html = html.replace(/<\/tr>/g, "\n");
//   html = html.replace(/<\/p>/g, "\n");
//   html = html.replace(/<\/div>/g, "\n");
//   html = html.replace(/<div>/g, "");
//   html = html.replace(/<\/h>/g, "\n");
//   html = html.replace(/<br>/g, "\n"); 
//   html = html.replace(/<br( )*\/>/g, "\n");
//   // console.log('Stripped: ', html)
//   //parse html into text
//   // var dom = (new DOMParser()).parseFromString('<!doctype html><body>' + html, 'text/html');
//   // return dom.body.textContent;
//   return html;
// }

const JobSite = (props) => {
  console.log('Job Site Modal: ', props)
  const history = useHistory()
  const classes = useStyles();
  const [open, setOpen] = React.useState(props.open)
  const [loading, setLoading] = React.useState(false)
  const [jobNumber, setJobNumber] = React.useState(null)
  const [propertyLines, setPropertyLines] = React.useState([])
  const mapContainerRef = React.useRef(null)
  const mapRef = React.useRef(null)
  // const [jobSite, setJobSite] = React.useState({})
  const [state, setState] = React.useState({
    jobName: props.client.displayName + '-',
    billingAddress: {},
    jobSiteAddress: '',
    jobSite: {},
    communityName: ' ',
    directions: '',
    gateCode: '',
    salesRep: {},
    billingAddy: {},
    notes: '',
    jobSiteName: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zipcode: '',
    _id: null,
    defaultSite: false,
    latitude: null,
    longitude: null,
    buildingNumber: '',
    radius: 200,
    excludeFromSiteReviews: false,
    irrigationCrew: null,
    irrigationCrewOverride: null,
    noIrrigationSystem: false
  })
  React.useEffect(() => {
    // console.log('Use Effect New jobSiteName')
    // let jobName = 'Job - '
    // if (props.client.lastName) jobName = props.client.lastName + '- '
    // if (props.client.companyName) jobName = props.client.companyName + '- '
    setOpen(props.open)
    let jobSite = props.jobSite
    let longitude = jobSite.longitude || 0
    let latitude = jobSite.latitude || 0
    if (jobSite && jobSite.location && jobSite.location.coordinates && jobSite.location.coordinates.length) {
      longitude = jobSite.location.coordinates[0]
      latitude = jobSite.location.coordinates[1]
    }
    let irrigationCrew
    let irrigationCrewOverride
    let noIrrigationSystem = jobSite?.noIrrigationSystem || false
    if (jobSite?.irrigationCrew) {
      irrigationCrew = props.crews.find(crew => (crew?._id?.toString() === jobSite?.irrigationCrew))
    }
    if (jobSite?.irrigationCrewOverride) {
      irrigationCrewOverride = props.crews.find(crew => (crew?._id?.toString() === jobSite?.irrigationCrewOverride))
    }

    setState({
      ...state,
      directions: jobSite.directions,
      communityName: jobSite.communityName,
      gateCode: jobSite.gateCode,
      notes: jobSite.cleanSiteNotes,
      jobSiteName: jobSite.name,
      jobSite: jobSite,
      address: jobSite.address,
      address2: jobSite.address2,
      city: jobSite.city,
      state: jobSite.state,
      zipcode: jobSite.zip,
      _id: jobSite._id,
      defaultSite: jobSite.isDefault,
      longitude: longitude,
      latitude: latitude,
      buildingNumber: jobSite.buildingNumber,
      radius: jobSite.radius,
      excludeFromSiteReviews: jobSite.excludeFromSiteReviews || false,
      irrigationCrew: irrigationCrew,
      irrigationCrewOverride: irrigationCrewOverride,
      noIrrigationSystem
    })
    // setState({...state, jobName: jobName})
  }, [props])

  // Fetch manual property lines when we have a jobsite id
  React.useEffect(() => {
    const siteId = props.jobSite?._id
    if (!siteId || !props.open) {
      setPropertyLines([])
      return
    }
    axios.get(`${props.url}/api/customer/getAPNAndParcelInfo?id=${siteId}&includeManual=true`)
      .then(response => {
        // Only show manual property lines (user-drawn), not auto parcel data
        const manualLines = response?.data?.manualPropertyLines || []
        const lines = manualLines
          .filter(ml => !ml.isHidden && ml.paths?.length > 0)
          .map(ml => ({
            name: ml.name,
            paths: ml.paths.map(pt => ({ lat: pt.lat, lng: pt.lng })),
            style: ml.style
          }))
        setPropertyLines(lines)
      })
      .catch(() => setPropertyLines([]))
  }, [props.jobSite?._id, props.open])

  // Initialize / update the Leaflet mini map
  React.useEffect(() => {
    // Clean up old map when modal closes
    if (!props.open) {
      if (mapRef.current) {
        mapRef.current.remove()
        mapRef.current = null
      }
      return
    }

    const lat = state.latitude
    const lng = state.longitude
    if (!lat || !lng || !mapContainerRef.current) return

    // Destroy previous map instance if coords changed
    if (mapRef.current) {
      mapRef.current.remove()
      mapRef.current = null
    }

    const map = L.map(mapContainerRef.current, {
      center: [lat, lng],
      zoom: 18,
      zoomControl: true,
      attributionControl: false
    })

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 21
    }).addTo(map)

    // Site marker
    const icon = L.divIcon({
      html: '<div style="background:#1976d2;color:white;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:16px;border:2px solid white;box-shadow:0 2px 4px rgba(0,0,0,0.3);">&#9873;</div>',
      iconSize: [28, 28],
      iconAnchor: [14, 14],
      className: ''
    })
    L.marker([lat, lng], { icon }).addTo(map)
      .bindPopup(`<b>${state.jobSiteName || 'Job Site'}</b><br/>${state.address || ''}`)

    const bounds = L.latLngBounds([[lat, lng]])

    // Manual property line polygons
    if (propertyLines.length > 0) {
      propertyLines.forEach(line => {
        if (!line.paths || line.paths.length === 0) return
        const poly = L.polygon(line.paths, {
          color: line.style?.color || '#4caf50',
          weight: line.style?.weight || 3,
          opacity: line.style?.opacity || 0.8,
          fillColor: line.style?.fillColor || '#4caf50',
          fillOpacity: line.style?.fillOpacity || 0.1,
          interactive: false
        })
        if (line.name) poly.bindTooltip(line.name)
        poly.addTo(map)
        bounds.extend(poly.getBounds())
      })
    }

    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [30, 30], maxZoom: 19 })
    }

    mapRef.current = map
    setTimeout(() => { if (mapRef.current) mapRef.current.invalidateSize() }, 250)

    return () => {
      if (mapRef.current) {
        mapRef.current.remove()
        mapRef.current = null
      }
    }
  }, [props.open, state.latitude, state.longitude, propertyLines])

const handleClose = () => {
  // console.log('Closing New Job Modal')
  // setOpen(false)
  setState({
    ...state,
    jobName: props.client.displayName + '-',
    billingAddress: {},
    jobSiteAddress: '',
    jobSite: {},
    salesRep: {},
    billingAddy: {},
    directions: '',
    communityName: '',
    gateCode: '',
    notes: '',
    jobSiteName: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zipcode: '',
    _id: null,
    defaultSite: false,
    latitude: null,
    longitude: null,
    buildingNumber: '',
    radius: 200,
    excludeFromSiteReviews: false,
    irrigationCrew: null,
    irrigationCrewOverride: null,
    noIrrigationSystem: false
  })
  props.updateParent('Close')
}

const handleConfirm = (data) => {
  // console.log('CONFIRMED NEW JOB!!', data)
}
const handleSave = () => {
  setLoading(true)
  // console.log('handle save', state)
  // console.log(props)
  let obj = {
    client: props.client,
    data: state,
    user: props.user
  }
  axios({
    method: 'post',
    url:  `${props.url}/api/customer/updateJobSite`,
    data: obj,
    // validateStatus: (status) => {
    //   // console.log('Validate status: ', status)
    //   if (status && status === 500) {

    //   }
    // },
  }).then(response => {
    // console.log('Axios response to create new Job Site: ', response)
    setLoading(false)
    if (response && response.data && response.data._id) {
      setState(prev => ({...prev, ...response.data}))
      props.updateParent('Updated', response.data)
      // Update our jobsites...set
      if (response.data.noGeoCoords) {
        props.notification({
          type: 'warning',
          title: 'Issue Obtaining GPS Coordinates for this Address.',
          message: 'Please try formatting the address a different way. We use Google Maps for these so if you search for this address on Google Maps and then COPY & PASTE it we should be good!'
        })
      } else {
       
        props.notification({
          type: 'success',
          title: 'New Job Site was created and saved!',
          message: 'Well Done!!'
        })
      }
    }
    // setState({})
    // setJobNumber(response.data)
    // if (response.data.number) {
    //   props.jobDetailsResponse(response.data)
    //   setState({})
    //   props.notification({
    //     type: 'success',
    //     title: 'Workorder ' + response.data.Job + ' was created and saved!',
    //     message: 'Well Done!!'
    //   })
    //   // setOpen(false)
    // } else {
    //   // console.log('No fucking workorder')
    //   props.notification({
    //     type: 'warning',
    //     title: 'Uh Oh!',
    //     message: 'Something messed up creating this workorder...not sure why!'
    //   })
    // }
    
  }).catch(err => {
    // console.log('Error saving Job Site: ', err)
  })
}

const updateBillingAddress = (e, addy) => {
  // console.log('Update Billing Address: ', e)
  // console.log(addy)
  if (addy && addy.address) {
    setState({...state, billingAddress: addy})
  }
}
const updateJobSiteAddress = (e, addy) => {
  // console.log('Update Job Site Address: ', e)
  // console.log(addy)
  if (addy && addy.address) {
    setState({...state, jobSite: addy.id, jobSiteAddress: addy})
  }
}
const updateSalesRep = (e, rep) => {
  // console.log('Update Sales rep ', e)
  // console.log(rep)
  if (rep && rep._id) {
    setState({...state, salesRep: rep})
  }
}

const CloseButton = () => {
  return (
    <IconButton onClick={handleClose} style={{ 'position': 'absolute', 'top': '15px', 'right': '30px' }} edge='end' alt="Close" aria-label="Close">
      <CloseIcon />
    </IconButton>
  )
}
const handleDelete = () => {
  // console.log('Delete!!!')
  setLoading(true)
  // console.log('handle save', state)
  // console.log(props)
  let obj = {
    client: props.client,
    data: state,
    user: props.user
  }
  axios({
    method: 'post',
    url:  `${props.url}/api/customer/deleteJobSite`,
    data: obj,
    // validateStatus: (status) => {
    //   // console.log('Validate status: ', status)
    //   if (status && status === 500) {

    //   }
    // },
  }).then(response => {
    // console.log('Axios response to Delete Job Site: ', response)
    setLoading(false)
    if (response && response.data && response.data._id) {
      // props.updateParent('Updated', response.data)
      props.updateParent('Delete', props.jobSite)
      props.notification({
        type: 'success',
        title: 'Job Site Deleted!',
        message: 'Well Done!!'
      })
    }    
  }).catch(err => {
    // console.log('Error Deleting Job Site: ', err)
  })
  
}

const handleToggleNoIrrigationSystem = () => {
  setState(prev => ({
    ...prev,
    noIrrigationSystem: !state.noIrrigationSystem
  }))
}

const handleLocateOnGmap = () => {
  console.log('Handle Locate on map....')
  let url = `/site-takeoff-v2/${props?.jobSite?._id}`
  // history.push(`/clientmapview/${props?.jobSite?._id}`, { jobSite: props.jobSite })
  // let addy = props.jobSite.address + ' ' + props.jobSite.city + ', AZ'
  // let encodedAddy = encodeURI(addy)
  // console.log('Encoded', encodedAddy)
  // // https://www.google.com/maps?sca_esv=bf0162ff70821237&sca_upv=1&output=search&q=15255+n+40th+st&source=lnms&entry=mc&ved=1t:200715&ictx=111
  // let url = `https://www.google.com/maps?q=${encodedAddy}&t=k&f=q&spn=15&view=map`
  // console.log('URL:', url)
  window.open(url, "_blank")
}

return (
  <div className={classes.root}>
    <Dialog open={open} fullWidth={true} onClose={handleClose} maxWidth='md' aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Job Site Details</DialogTitle>
        <CloseButton />   
        <DialogContent >
          <Button
          variant="contained"
          style={{backgroundColor: '#ed4545'}}
          className={classes.button}
          size="small"
          startIcon={<DeleteIcon />}
          onClick={() => { if (window.confirm('Are you sure you wish to delete this Job Site?')) handleDelete() }}
        >
          Delete
        </Button>
        <Grid container>
            <Grid item lg={8}>
              <DialogContentText>
                  You Can Update The Details Below
              </DialogContentText>
            </Grid>
            <Grid item lg={4}>

                <IconButton onClick={handleLocateOnGmap}  alt="View On Map" aria-label="View On Map">
                  <FindInPageIcon size={16} />
                </IconButton>
                
            </Grid>
            <Grid item lg={8}>
              <TextField
                autoFocus
                className={classes.paddedStuff}
                margin="dense"
                id="JobSiteName"
                label="Site Name"
                type="text"
                onChange={(e) => setState({...state, jobSiteName: e.target.value})}
                value={state.jobSiteName}
                fullWidth
              />
            </Grid>
           <Grid item lg={4}>
           <FormGroup >
                <FormControlLabel
                    control={<Checkbox checked={state.defaultSite} onChange={ e => setState({...state, defaultSite: !state.defaultSite } ) } name="Active Site" />}
                    label="Default Site"
                  />
              </FormGroup>
              <FormGroup >
                <FormControlLabel
                    control={<Checkbox checked={state.excludeFromSiteReviews} onChange={ e => setState({...state, excludeFromSiteReviews: !state.excludeFromSiteReviews } ) } name="Exclude From Site Reviews" />}
                    label="Exclude From Regular Site Reviews"
                  />
              </FormGroup>

              
            {/* <TextField
            autoFocus
            className={classes.paddedStuff}
            margin="dense"
            id="JobSiteDefault"
            label="Default Site"
            type="text"
            onChange={(e) => setState({...state, defaultSite: e.target.value})}
            value={state.defaultSite}
            fullWidth
          /> */}
            </Grid>
           
            <Grid item lg={4} md={4} sm={6} xs={6}>
            <TextField
            className={classes.paddedStuff}
            margin="dense"
            id="CommunityName"
            label="Community Name"
            type="text"
            onChange={(e) => setState({...state, communityName: e.target.value})}
            value={state.communityName}
            fullWidth
          />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6}>
              <TextField
              autoFocus
              className={classes.paddedStuff}
              margin="dense"
              id="jobsitebuildingNumber"
              label="Building Number"
              type="text"
              onChange={(e) => setState({...state, buildingNumber: e.target.value})}
              value={state.buildingNumber}
              fullWidth
            />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6}>
            <TextField
            
            className={classes.paddedStuff}
            margin="dense"
            id="GateCode"
            label="Gate Code"
            type="text"
            onChange={(e) => setState({...state, gateCode: e.target.value})}
            value={state.gateCode}
            fullWidth
          />
            </Grid>
            <Grid item lg={12}>
            <TextField
            className={classes.paddedStuff}
            margin="dense"
            id="JobSiteAddress"
            label="Job Site Address"
            type="text"
            onChange={(e) => setState({...state, address: e.target.value})}
            value={state.address}
            fullWidth
          />
            </Grid>
            {/* <Grid item lg={12}>
            <TextField
            className={classes.paddedStuff}
            margin="dense"
            id="JobSiteAddress2"
            label="Job Site Address 2"
            type="text"
            onChange={(e) => setState({...state, address2: e.target.value})}
            value={state.address2state}
            fullWidth
          />
            </Grid> */}
            <Grid item lg={6} xs={6} className={classes.gridItem}>
              <TextField
                label="Job Site City"
                fullWidth
                value= {state.city}
                onChange={ e => setState({...state, city:e.target.value } ) }
                // variant="outlined"
                // value= {state.service.time}
                // onChange={ e => handleServiceChange(state.service, 'time', e.target.value, state.serviceIndex) }
                // defaultValue="Default Value"
                />
            </Grid>
            <Grid item lg={3} xs={6} className={classes.gridItem}>
              <TextField
                label="Job Site State"
                fullWidth
                value= {state.state}
                onChange={ e => setState({...state, state:e.target.value } ) }
              />
            </Grid>
            <Grid item lg={3} xs={6} className={classes.gridItem}>
            <TextField
                label="Job Site Zipcode"
                fullWidth
                // type="number"
                // variant="outlined"
                value= {state.zipcode}
                onChange={ e => setState({...state, zipcode:e.target.value } ) }
                />
            </Grid>
            {/* Mini Map with Property Lines */}
            {state.latitude && state.longitude ? (
              <Grid item lg={12} xs={12} className={classes.gridItem}>
                <div
                  ref={mapContainerRef}
                  style={{
                    height: 280,
                    width: '100%',
                    borderRadius: 8,
                    border: '1px solid #ccc',
                    overflow: 'hidden',
                    position: 'relative',
                    zIndex: 1
                  }}
                />
                {propertyLines.length > 0 && (
                  <div style={{ fontSize: '0.75rem', color: '#888', marginTop: 4 }}>
                    {propertyLines.length} property line{propertyLines.length !== 1 ? 's' : ''} shown
                    {propertyLines[0]?.name ? ` — ${propertyLines[0].name}` : ''}
                  </div>
                )}
              </Grid>
            ) : null}

            <Grid item lg={4} xs={6} className={classes.gridItem}>
            <TextField
                label="Job Site Latitude"
                fullWidth
                // type="number"
                // variant="outlined"
                value= {state.latitude}
                onChange={ e => setState({...state, latitude:e.target.value } ) }
                />
            </Grid>
            <Grid item lg={4} xs={6} className={classes.gridItem}>
            <TextField
                label="Job Site Longitude"
                fullWidth
                // type="number"
                // variant="outlined"
                value= {state.longitude}
                onChange={ e => setState({...state, longitude:e.target.value } ) }
                />
            </Grid>
            <Grid item lg={4} xs={12} className={classes.gridItem}>
              <TextField
                label="Job Site Radius (Meters)"
                fullWidth
                // type="number"
                // variant="outlined"
                value= {state.radius}
                onChange={ e => setState({...state, radius: e.target.value } ) }
                helperText="Standard is 200m, but some sites are much larger"
                />
            </Grid>
            <Grid item lg={12} xs={12} className={classes.gridItem}>
            <TextField
                label="Job Site Notes"
                fullWidth
                // type="number"
                // variant="outlined"
                value= {state.notes}
                onChange={ e => setState({...state, notes:e.target.value } ) }
                />
            </Grid>
            <Grid item lg={12} xs={12} className={classes.gridItem}>
            <TextField
                label="Job Site Directions"
                fullWidth
                // type="number"
                // variant="outlined"
                value= {state.directions}
                onChange={ e => setState({...state, directions:e.target.value } ) }
                />
            </Grid>
            <Grid item md={6} xs={12} className={classes.gridItem}>
              <FormControlLabel
                control={
                  <Switch
                    checked={state.noIrrigationSystem}
                    onChange={handleToggleNoIrrigationSystem}
                    color="primary"
                  />
                }
                label={state.noIrrigationSystem ? `Property Has No Irrigation` : `Property Has Irrigation (Requires Inspections)`}
              />
            </Grid>
            <Grid item lg={12} xs={12} className={classes.gridItem}>
              {
                state.noIrrigationSystem ? null : 
              
                <CrewSelector
                  crews={props.crews}
                  state={state}
                  setState={setState}
                  classes={classes}
                />
              }
            </Grid>
            

            <Grid item md={12} xs={12} className={classes.gridItem}>
              <KeyDetails jobSite={state} />
            </Grid>
          </Grid>
         
          
         

        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setState({...state, editJobName: false})} color="primary">
            Cancel
          </Button> */}
          <Button color="primary" disabled={loading || !state.state || !state.city || !state.address} onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
  </div>
  )
  }


  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification,
      crews: state.crews
    }
  }
  
  export default React.memo(connect(mapStateToProps)(JobSite))